import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function SocialProof() {
  const testimonials = [{
    text: 'Tenía miedo de perder mi dinero pero llega el link al instante y todo bien.',
    initials: 'M',
    color: 'bg-blue-600'
  }, {
    text: 'Lo amo, súper sencillo y me encanta la explicación de las cafeteras.',
    initials: 'C',
    color: 'bg-rose-600'
  }, {
    text: 'Al principio dudé porque pensé que era puro anuncio, pero sí llega y está súper bonito.',
    initials: 'A',
    color: 'bg-emerald-600'
  }, {
    text: 'Las recetas están buenísimas.',
    initials: 'L',
    color: 'bg-purple-600'
  }];
  return <section className="py-20 px-4 bg-cream-200" data-id="element-142">
      <div className="max-w-6xl mx-auto" data-id="element-143">
        <div className="text-center mb-16" data-id="element-144">
          <h2 className="text-3xl md:text-4xl font-bold text-espresso-900 mb-6" data-id="element-145">
            COMENTARIOS DE LOS CLIENTES
          </h2>
          <div className="flex items-center justify-center gap-2 mb-2" data-id="element-146">
            <div className="flex text-gold-500" data-id="element-147">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-8 h-8 fill-current" data-id="element-148" />)}
            </div>
          </div>
          <p className="text-2xl font-bold text-espresso-900" data-id="element-149">⭐ 4.8 / 5</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-150">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-espresso-900/5 flex flex-col" data-id="element-151">
              <div className="flex text-gold-500 mb-4" data-id="element-152">
                {[...Array(5)].map((_, idx) => <Star key={idx} className="w-4 h-4 fill-current" data-id="element-153" />)}
              </div>
              <p className="text-espresso-800 italic flex-1 mb-6" data-id="element-154">"{t.text}"</p>
              <div className="flex items-center gap-3" data-id="element-155">
                <div className={`w-10 h-10 rounded-full ${t.color} text-white flex items-center justify-center font-bold`} data-id="element-156">
                  {t.initials}
                </div>
                <div className="flex flex-col" data-id="element-157">
                  <span className="font-bold text-espresso-900 text-sm" data-id="element-158">
                    Cliente Verificado
                  </span>
                  <span className="text-xs text-espresso-700 flex items-center gap-1" data-id="element-159">
                    <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-160"></span>{' '}
                    Compra confirmada
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}